<div class="modal-header">
  <h5 class="modal-title">{{info.title}}</h5>
  <button type="button" class="close" (click)="onButtonClose($event)" id="cs-add-new-form-close-form-id">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="card-body p-0">
  <div class="wrap-content">
    <ng-content></ng-content>
  </div>
</div>
<div class="modal-footer">
  <div class="start">
    <button type="button" class="btn btnClose close-button"
            (click)="onButtonClose($event)" id="cs-add-new-form-button-close-id">Đóng
    </button>
  </div>
  <div class="end">
    <button *ngIf="!info.disableAddNewButton && !info.isSaveButton && !info.isDisableSaveAndNew" type="button" class="btn btn-primary btnSave save-new-button mr-2"
            (click)="onButtonSaveNew($event)">Lưu &amp; Thêm
    </button>
    <button  type="button" class="btn btn-primary btnSaveClose save-close-button" [ngClass]="{'next-btn': info.isNextButton}"
             (click)="onButtonSaveClose($event)">
      <span *ngIf="!info.isNextButton && !info.isSaveButton">Lưu &amp; Đóng</span>
      <span *ngIf="info.isNextButton && !info.isSaveButton">{{nextLabel}}</span>
      <span *ngIf="info.isSaveButton">Lưu</span>
    </button>
  </div>
</div>
